import {z} from 'zod'

export type Percentage = `${number}%`

export const MetaProps = z
    .object({
        currentPage: z.number(),
        firstPage: z.number(),
        firstPageUrl: z.string(),
        lastPage: z.number(),
        lastPageUrl: z.string(),
        nextPageUrl: z.string().nullable(),
        perPage: z.number(),
        previousPageUrl: z.string().nullable(),
        total: z.number(),
        searchAfter: z
            .array(z.union([z.number(), z.string()]))
            .nullable()
            .optional()
    })
    .optional()

export type MetaProps = z.infer<typeof MetaProps>

export const DataProps = z
    .array(
        z
            .object({
                id: z.string(),
                name: z.string().optional(),
                keyName: z.string().optional(),
                keyTarName: z.string().optional()
            })
            .optional()
    )
    .or(z.array(z.string()).optional())

export type DataProps = z.infer<typeof DataProps>

export const OptionsType = z.object({
    data: DataProps,
    meta: MetaProps
})

export type OptionsType = z.infer<typeof OptionsType>
